// API Configuration
export const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:8787';

// Color Constants (matching HTML)
export const COLORS = {
  primary: '#0052CC',
  primaryDark: '#003D99',
  primaryLight: '#3385FF',
  secondary: '#00A3E0',
  accent: '#FFB800',
  white: '#FFFFFF',
  bg: '#F5F8FC',
  bg2: '#EBF2FA',
  bg3: '#D9E7F7',
  text: '#0A1929',
  text2: '#2D3748',
  text3: '#4A5568',
  text4: '#718096',
  border: '#C9D7E8',
};

// Routes
export const ROUTES = {
  HOME: '/',
  COURSES: '/courses',
  COURSE_DETAIL: '/courses/:id',
  PRICING: '/pricing',
  ABOUT: '/about',
  CONTACT: '/contact',
  LOGIN: '/login',
  REGISTER: '/register',
  FORGOT_PASSWORD: '/forgot-password',
  RESET_PASSWORD: '/reset-password',
  DASHBOARD: '/dashboard',
  PROFILE: '/profile',
  MY_COURSES: '/dashboard/my-courses',
  MY_PROGRESS: '/dashboard/progress',
  MY_CONTENT: '/my-content',
  PAYMENT_SUCCESS: '/payment/success',
  PAYMENT_FAILURE: '/payment/failure',
  MANUAL_PAYMENT_REQUEST: '/manual-payment/:id',
  MANUAL_PAYMENTS: '/manual-payments',
  ANALYTICS: '/analytics',
  PURCHASES: '/purchases',
  BUNDLES: '/bundles',
  STORYBOOKS: '/storybooks',
  ADMIN: '/admin',
  NOTIFICATIONS: '/notifications',
};

// Local Storage Keys
export const STORAGE_KEYS = {
  AUTH_TOKEN: 'allemani_auth_token',
  USER_DATA: 'allemani_user_data',
};
